module.exports = __webpack_public_path__ + "img/9788983925602.c7278882.jpg";